import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { AuthService } from '@/app/services/auth.service';

export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return toObservable(authService.sessionInitialized).pipe(
        filter((initialized) => initialized),
        take(1),
        map(() => (authService.isLoggedIn() ? true : router.createUrlTree(['/auth/login']))),
    );
};
